import { render, staticRenderFns } from "./queryBackups.vue?vue&type=template&id=02bb48d9&scoped=true&"
import script from "./queryBackups.vue?vue&type=script&lang=js&"
export * from "./queryBackups.vue?vue&type=script&lang=js&"
import style0 from "./queryBackups.vue?vue&type=style&index=0&id=02bb48d9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02bb48d9",
  null
  
)

export default component.exports